<script setup>
import {ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {CountTo} from "vue3-count-to";
import router from "@/router/index.js";
import {listBicycles, exportBicycles, importBicycles} from "@/api/bicycles/bicycles.js"

/*搜索功能*/
// 表单数据
const formData = reactive({
  brandName: null,
  model: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true;
    const param = {
      ...formData,
      viewType: tab.value
    }
    const res = await listBicycles(page, param);
    bicycleTotalCount.value = res.bicycleTotalCount
    boundBicycleCount.value = res.boundBicycleCount
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.brandName = null
  formData.model = null
  handleSearch('btnSearch')
}
// 车辆总数
const bicycleTotalCount = ref(0)
// 已绑定车辆数
const boundBicycleCount = ref(0)

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 按车辆品牌查看headers
const brandHeaders = [
  { title: '车辆品牌', key: 'brandName', nowrap: true },
  { title: '车辆型号', key: 'model', nowrap: true },
  { title: '车辆颜色', key: 'color', nowrap: true },
  { title: '车辆使用年龄段', key: 'ageRange', nowrap: true },
  { title: '车辆新旧程度', key: 'conditionLevel', nowrap: true },
  { title: '提供方/赞助方', key: 'providerSponsor', nowrap: true },
  { title: '车辆当前放置场地', key: 'currentVenue', nowrap: true },
  { title: '车辆放置时间', key: 'placementDate', nowrap: true },
  { title: '车辆数量', key: 'bicycleQuantity', nowrap: true },
  { title: '车辆绑定占比', key: 'bindRatio', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
]
// 按赞助方查看
const sponsorHeaders = [
  { title: '提供方/赞助方', key: 'providerSponsor', nowrap: true },
  { title: '车辆品牌', key: 'brandName', nowrap: true },
  { title: '车辆型号', key: 'model', nowrap: true },
  { title: '车辆颜色', key: 'color', nowrap: true },
  { title: '车辆使用年龄段', key: 'ageRange', nowrap: true },
  { title: '车辆新旧程度', key: 'conditionLevel', nowrap: true },
  { title: '车辆当前放置场地', key: 'currentVenue', nowrap: true },
  { title: '车辆放置时间', key: 'placementDate', nowrap: true },
  { title: '车辆数量', key: 'bicycleQuantity', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
]
const headers = ref(brandHeaders)
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 当前选择的标签卡
const tab = ref("brand")
// 处理切换标签、标签组选项卡
const handleTabChange = (e) => {
  console.log("e", e)
  if (e === 'BRAND') {
    headers.value = brandHeaders
  } else {
    headers.value = sponsorHeaders
  }
  handleReset()
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/addBicycleInventory")
}
// 导入模板下载地址
const importTemplateUrl = "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/templateFiles/%E8%BD%A6%E8%BE%86%E7%AE%A1%E7%90%86%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx"
// 处理下载批量导入车辆文件示例
const handleDownLoadTempFile = () => {
  window.location.href = importTemplateUrl
}
/*批量导入车辆*/
// 批量导入车辆弹窗开关
const openBatchImport = ref(false)
// 批量导入车辆文件
const uploadFile = ref(null)
// 批量导入车辆上传锚点
const uploadRef = ref()
// 批量导入车辆弹窗加载状态
const batchImportLoading = ref(false)
// 判断文件是否excel
const isExcelFile = (file) => {
  const fileName = file.name || ''
  const fileType = file.type || ''
  const isExcelType =
      fileType === 'application/vnd.ms-excel' ||
      fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  const isExcelSuffix = /\.(xls|xlsx)$/i.test(fileName)
  return isExcelType || isExcelSuffix
}
// 处理点击批量导入车辆按钮
const handleBicycleBatchImport = () => {
  openBatchImport.value = true
}
// 处理批量导入车辆文件修改
const handleFileChange = (file) => {
  const rawFile = file.raw
  if (!rawFile) return

  const isExcel = isExcelFile(rawFile)
  const isLt10M = rawFile.size / 1024 / 1024 <= 10

  if (!isExcel) {
    ElMessage.error('仅支持 xls、xlsx 格式')
    uploadFile.value = null
    uploadRef.value?.clearFiles()
    return
  }

  if (!isLt10M) {
    ElMessage.error('文件大小不能超过 10MB')
    uploadFile.value = null
    uploadRef.value?.clearFiles()
    return
  }

  uploadFile.value = rawFile
}
// 处理批量导入车辆文件删除
const handleFileRemove = () => {
  uploadFile.value = null
  uploadRef.value?.clearFiles()
}
// 处理批量导入车辆文件超出限制
const handleFileExceed = () => {
  ElMessage.error('最多只能上传 1 个文件')
}
// 批量导入车辆文件上传之前校验
const beforeUpload = (file) => {
  const isExcel = isExcelFile(file)
  const isLt10M = file.size / 1024 / 1024 <= 10

  if (!isExcel) {
    ElMessage.error('仅支持 xls、xlsx 格式')
    return false
  }

  if (!isLt10M) {
    ElMessage.error('文件大小不能超过 10MB')
    return false
  }

  return true
}
// 格式化上传文件大小
const formatFileSize = (size) => {
  if (!size && size !== 0) return '-'
  if (size < 1024) return `${size}B`
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)}KB`
  if (size < 1024 * 1024 * 1024) return `${(size / 1024 / 1024).toFixed(2)}MB`
  return `${(size / 1024 / 1024 / 1024).toFixed(2)}GB`
}
// 处理批量导入车辆弹窗关闭
const handleBatchImportClose = () => {
  openBatchImport.value = false
  uploadFile.value = null
  uploadRef.value?.clearFiles()
}
// 处理批量导入车辆点击确定
const handleBatchImportSubmit = async () => {
  try {
    if (!uploadFile.value) {
      ElMessage.warning('请先上传文件')
      return
    }
    batchImportLoading.value = true
    const uploadFormData = new FormData()
    uploadFormData.append('file', uploadFile.value)
    const res = await importBicycles(uploadFormData)
    ElMessage.success('批量导入车辆成功')
    handleBatchImportClose()
    handleSearch('btnSearch')
  } catch (e) {
    console.log(e)
    ElMessage.error('批量导入车辆失败')
  } finally {
    batchImportLoading.value = false
  }
}
// 批量下载车辆信息
const handleExportBicycles = async () => {
  try {
    loading.value = true
    const param = {
      brandName: formData.brandName,
      model: formData.model,
      viewType: tab.value
    }
    const res = await exportBicycles(param)
    const blob = new Blob([res.data])
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.setAttribute("download", "车辆信息.xlsx")
    document.body.appendChild(link)
    link.click()
    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
    }, 100)
  } catch (e) {
    console.log(e)
  } finally {
    loading.value = false
  }
}

/*操作栏相关*/
// 跳转详情
const handleDetail = (item) => {
  router.push({
    path: `/editBicycleInventory`,
    query: {
      bicycleId: item.bicycleId
    }
  })
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;gap: 15px;">
      <v-btn color="success" @click="handleAdd">
        <template v-slot:default>
          <div class="flex_bt">
            <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
            />
            <span>新增车辆</span>
          </div>
        </template>
      </v-btn>
      <v-btn color="success" @click="handleBicycleBatchImport">批量导入车辆</v-btn>
      <el-link type="primary" :href="importTemplateUrl" target="_blank">导入模板下载</el-link>
    </div>
  </div>
  <div class="container_box flex mg_b_2" style="padding: 16px;">
    <div class="dataBox mg_r_2" style="position: relative">
      <div class="dataBox_SubTitle">车辆总数</div>
      <countTo
          :title="0"
          class="dataBox_title txt_overflow"
          :startVal="0"
          :endVal="parseInt(bicycleTotalCount)"
          :duration="3000"
      ></countTo>
    </div>
    <div class="dataBox mg_r_2" style="position: relative">
      <div class="dataBox_SubTitle">已绑定车辆</div>
      <countTo
          :title="0"
          class="dataBox_title txt_overflow"
          :startVal="0"
          :endVal="parseInt(boundBicycleCount)"
          :duration="3000"
      ></countTo>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="start">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.brandName"
                        placeholder="请输入车辆品牌"
                        label="车辆品牌"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.model"
                        placeholder="请输入车辆型号"
                        label="车辆型号"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div class="flex_bt">
              <v-tabs
                  class="mg_r_3"
                  v-model="tab"
                  color="primary"
                  @update:modelValue="handleTabChange"
              >
                <v-tab value="BRAND">按车辆品牌查看</v-tab>
                <v-tab value="SPONSOR">按赞助方查看</v-tab>
              </v-tabs>
              <v-btn color="success" @click="handleExportBicycles">下载</v-btn>
            </div>
          </template>

          <template v-slot:item.bindRatio="{ item }">
            <el-text type="success">{{item.bindRatio}}</el-text>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="qr-controls">
              <el-link type="primary" :underline="false" @click="handleDetail(item)">详情</el-link>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>

  <el-dialog
      v-model="openBatchImport"
      width="610"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
  >
    <template #header>
      <div class="yt_dialog_title" style="padding-bottom: 30px">批量导入车辆</div>
    </template>
    <div class="yt_dialog_container" style="padding: 0 45px;" v-loading="batchImportLoading">
      <el-upload
          ref="uploadRef"
          class="upload-demo"
          drag
          :auto-upload="false"
          :limit="1"
          accept=".xls,.xlsx"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :before-upload="beforeUpload"
          :on-exceed="handleFileExceed"
      >
        <div class="flex_center" style="margin-bottom: 18px;">
          <img style="width: 26px;height: 26px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_dragger_upload.svg"/>
        </div>
        <div class="dragger_upload_txt" style="margin-bottom: 17px;">
          点击或拖拽文件
        </div>
        <div class="flex">
          <div class="dragger_upload_tips">注：</div>
          <div class="dragger_upload_tips">
            <div>1、可参考模板文件 <span class="download_link" @click.stop="handleDownLoadTempFile">批量导入车辆文件示例</span> 来进行车辆的批量导入。</div>
          </div>
        </div>
        <template #tip>
        </template>
        <template #file="{ file }">
          <div class="flex_bt file_box">
            <div class="flex_center flex_left">
              <img class="mg_r_1" style="width: 18px;height: 20px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/templateFiles/default_excel_icon.svg"/>
              <div class="file_name">{{file.name}}<span style="color: #6F717D;">({{formatFileSize(file.size)}})</span></div>
            </div>
            <div style="cursor: pointer" @click="handleFileRemove">
              <img style="width: 12px;height: 12px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/file_upload_close.svg"/>
            </div>
          </div>
        </template>
      </el-upload>
    </div>
    <template #footer>
      <div class="yt_dialog_footer">
        <v-btn color="#d7d7df" variant="elevated" @click="handleBatchImportClose">取消</v-btn>
        <v-btn class="mg_l_2" :disabled="batchImportLoading" color="#4CAF50" variant="elevated" @click="handleBatchImportSubmit">确定</v-btn>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.qr-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/*弹窗标题*/
.yt_dialog_title {
  padding: 20px 0 17px 33px;
  font-weight: 500;
  font-size: 19px;
  color: #272539;
  text-align: left;
}

/*弹窗内容*/
.yt_dialog_container {
  padding-left: 33px;
  text-align: left;
}

/*弹窗底部按钮栏*/
.yt_dialog_footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 33px 33px 0;
}

:deep(.el-upload-dragger) {
  border-color: rgba(25,24,27,0.06);
  border-radius: 10px;
  background: #F9FAFD;
  padding: 29px 24px;
}

:deep(.el-upload-dragger:hover) {
  border-color: #272539;
  color: #272539;
}

.dragger_upload_txt {
  font-family: OPPOSans;
  font-weight: 500;
  font-size: 19px;
  color: #272539;
  line-height: 19px;
  text-align: center;
}

.dragger_upload_tips {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 11px;
  color: #9398A9;
  line-height: 17px;
  text-align: left;

  .download_link {
    color: #684FA2;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.file_box {
  height: 32px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #DADDE2;
  box-sizing: border-box;
  padding: 0 19px;

  .file_name {
    font-family: OPPOSans;
    font-weight: 400;
    font-size: 12px;
    color: #272539;
  }
}
</style>
